require('jquery-mousewheel');
require(
  'imports-loader?define=>false,jQuery=jquery!' +
  './jquery.position.js'
);
